module.exports = __webpack_public_path__ + "static/media/bottom_qr.e247e91f.png";